import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "5G関連サービス「ドコモオープンイノーべションクラウド」を開発いたしました。このサービスは、5Gを活用したサービス開発者向けのものです。弊社はプロジェクト支援、サービス設計、クラウドをフル活用したサーバーレスアーキテクチャでのウェブシステムの開発を実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const nttPageMeta: PageMeta = {
  title: "docomo Open Inovation Cloud | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "UIUX フロントエンド開発 ヒューリスティック調査 情報設計 ",
  image: primaryImage,
  url: `${SITE_URL}/cases/ntt/`,
}

export const nttSchema = buildCaseStudySchema({
  slug: "ntt",
  pageTitle: nttPageMeta.title,
  description: nttPageMeta.description,
  headline: "docomo Open Inovation Cloud",
  alternativeHeadline: "株式会社NTTドコモ",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/ntt.webp"],
  clientName: "株式会社NTTドコモ",
  breadcrumbLabel: "docomo Open Inovation Cloud",
})
